var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('details',[_c('summary',[_c('p',{staticClass:"list"},[_vm._v(_vm._s(_setup.t('report.group_by')))])]),_c('p',{staticClass:"list text"},[_vm._v(_vm._s(_setup.t('widget_info_text.group_x_axis_by')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }